import { handleActions } from "redux-actions";
import {
  SET_LOADING,
  SET_CONSTANTS,
  FETCH_MODULE,
  SET_FILTERS_LOADING,
  SET_ALL_SITES_MODE,
  TOGGLE_VIEW,
  FETCH_FILTERS,
  UPDATE_FILTERS,
  UPDATE_REFERRAL_CATEGORIES,
  REFERRAL_BY_SOURCE
} from "../sagas/referrals";
import { getSelectedRangeOptionWithCustom } from "../../../../utils/date-range-options";
import { getInitialRangeOptions } from "../../constants";

export const initialState = {
  dataTable: {},
  initialRequest: false,
  options: {},
  listeners: [],
  isFiltersLoading: false,
  isLoading: true,
  material: false,
  isTable: false,
  isAllSitesMode: false,
  disabledUpdateButton: false,
  filters: {
    categories: "",
    filtersDirty: false,
    referralCategory: false,
    willUpdateFilters: false,
    selectedProspectTypes: []
  }
};

const getActionKey = (key) => key + "/" + REFERRAL_BY_SOURCE;

export default handleActions(
  {
    [getActionKey(SET_LOADING)]: (state, { payload }) => ({
      ...state,
      isLoading: payload
    }),

    [getActionKey(SET_CONSTANTS)]: (state, { payload }) => ({
      ...state,
      ...payload,
      initialRequest: true
    }),
    [getActionKey(TOGGLE_VIEW)]: (state, { payload }) => ({ ...state, isTable: payload }),
    [getActionKey(SET_FILTERS_LOADING)]: (state, { payload }) => ({
      ...state,
      isFiltersLoading: payload,
      disabledUpdateButton: payload
    }),
    [getActionKey(UPDATE_FILTERS)]: (state, { payload }) => ({
      ...state,
      filters: { ...state.filters, filtersDirty: true, ...payload }
    }),
    [getActionKey(SET_ALL_SITES_MODE)]: (state, { payload }) => ({
      ...state,
      isAllSitesMode: { ...state, payload }
    }),
    [getActionKey(UPDATE_REFERRAL_CATEGORIES)]: (state, { payload: { ...rest } }) => {
      const categories = rest.classTypes.options.categories;
      return {
        ...state,
        filters: {
          ...state.filters,
          referralValues: categories,
          referralCategories: categories,
          referralCategory:
            state.filters?.referralCategory === undefined
              ? initialState.filters.referralCategory
              : state.filters.referralCategory,
          ...rest
        }
      };
    },
    [getActionKey(FETCH_MODULE)]: (state, { payload: { data_table: dataTable, ...rest } }) => ({
      ...state,
      ...rest,
      filters: { ...state.filters, filtersDirty: false },
      isLoading: false,
      dataTable
    }),
    [getActionKey(FETCH_FILTERS)]: (
      state,
      { payload: { start_date: startDate, end_date: endDate, ...rest } }
    ) => {
      const categories = rest.classTypes.options.categories;
      // fetch filters always reinitializes all filters with default values
      return {
        ...state,
        isTable: false,
        filters: {
          ...initialState.filters,
          ...rest,
          selectedProspectTypes: rest.prospect_types || initialState.filters.selectedProspectTypes,
          referralValues: categories,
          referralCategories: categories,
          referralCategory:
            state.filters?.referralCategory === undefined
              ? initialState.filters.referralCategory
              : state.filters.referralCategory,
          startDate,
          endDate,
          rangeValue: getSelectedRangeOptionWithCustom({ payload: { startDate, endDate } }), // set as current selected
          // get preexisting range options from getRangeOptions function + Custom Range
          rangeOptions: getInitialRangeOptions(startDate, endDate, state.theBeginningOfTime).filter(
            (option) => !option.name.includes("Last 30 Days")
          )
        }
      };
    }
  },
  initialState
);
